import styled from 'styled-components';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';
import { MOBILE_VIEWPORT_QUERY } from '@/shared/hooks/useIsMobile';
import { TOP_EVENTS_INSET, TOP_EVENTS_INSET_QUERY } from '../../model/configs';

export const FixedSkeletonLoader = styled(SkeletonLoader)`
  && {
    flex: none;
    width: 505px;
    height: 249px;

    @media ${MOBILE_VIEWPORT_QUERY} {
      width: 260px;
      height: 270px;
    }
  }
`;

export const SkeletonRow = styled.div`
  display: flex;
  min-width: 0;
  gap: 10px;

  @media ${TOP_EVENTS_INSET_QUERY} {
    flex: none;
    padding: 0 ${TOP_EVENTS_INSET}px;
  }
`;
